import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { apiUrl, toFormData } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class AllPageService {

constructor(
  private http: HttpClient,
) { }

getBannerList(request?:any) {
  return this.http.post(apiUrl('beforeauth/getbannerlist'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getFaq(request?:any) {
  return this.http.post(apiUrl('beforeauth/getfaq'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getFootersponsors(request?:any) {
  return this.http.post(apiUrl('beforeauth/getfootersponsors'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getContactText(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcontacttext'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getSponsors(request?:any) {
  return this.http.post(apiUrl('beforeauth/getsponsorscatagory'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getNewsCatagory(request?:any) {
  return this.http.post(apiUrl('beforeauth/getnewscatagory'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getNewsListing(request?:any) {
  return this.http.post(apiUrl('beforeauth/getnewsletter'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getVideoListing(request?:any) {
  return this.http.post(apiUrl('beforeauth/getvideo'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}
getHomeScreenTcard(request?:any) {
  return this.http.post(apiUrl('beforeauth/gethomescreentcard'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}
getHomescreenNewsletter() {
  return this.http.post(apiUrl('beforeauth/gethomescreennewsletter'),{}).toPromise().then((data:any)=>{   
      return data;
  })
}
getHomeScreenMatchesList(request?:any) {
  return this.http.post(apiUrl('beforeauth/gethomescreenmatcheslist'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getMatchelistwithout(request?:any) {
  return this.http.post(apiUrl('beforeauth/getmatcheslistwithoutpagination'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getSeasontype(request?:any) {
  return this.http.post(apiUrl('beforeauth/getseasontype'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getMatcheslist(request?:any) {
  return this.http.post(apiUrl('beforeauth/getmatcheslist'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getMatcheslistnew(request?:any) {
  return this.http.post(apiUrl('beforeauth/getmatcheslistnew'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getPlayerlist(request?:any) {
  return this.http.post(apiUrl('beforeauth/getplayerlist'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getPlayerDetails(request?:any) {
  return this.http.post(apiUrl('beforeauth/getplayerdetails'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getNextplayers(request?:any) {
  return this.http.post(apiUrl('beforeauth/fatchplayerdata'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getPreviousplayers(request?:any) {
  return this.http.post(apiUrl('beforeauth/fatchplayerdata'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getEventtype(request?:any) {
  return this.http.post(apiUrl('beforeauth/geteventtype'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getMembership(request?:any) {
  return this.http.post(apiUrl('beforeauth/getmembership'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getContenttext(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcontacttext'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getPodcast(request?:any) {
  return this.http.post(apiUrl('beforeauth/getpodcast'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getMembershipFaq(request?:any) {
  return this.http.post(apiUrl('beforeauth/getmembershipfaq'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getMembershipDetails(request?:any) {
  return this.http.post(apiUrl('beforeauth/getmembershipdetails'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getAppsetting(request?:any) {
  return this.http.post(apiUrl('beforeauth/appsetting'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getCommercialPresident(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcommercialpresident'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getCommercialPartnership(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcommercialpartnership'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getCricketdetailimage(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcricketeventtitledetailimage'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getCommercialPlayer(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcommercialplayersponsorship'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getCommercialBoundary(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcommercialboundaryclub'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getCommercialledBig(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcommercialledbigscreen'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getCommercialHospitality(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcommercialmatchdayhospitality'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}


getMatchday(request?:any) {
  return this.http.post(apiUrl('beforeauth/getmatchday'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getHistoryofLccc(request?:any) {
  return this.http.post(apiUrl('beforeauth/gethistoryoflccc'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getHistorymuseum(request?:any) {
  return this.http.post(apiUrl('beforeauth/gethistorymuseum'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getHistoryCommittee(request?:any) {
  return this.http.post(apiUrl('beforeauth/gethistorycommitteemember'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getHistoryHonours(request?:any) {
  return this.http.post(apiUrl('beforeauth/gethistoryhonours'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getHistoryRecords(request?:any) {
  return this.http.post(apiUrl('beforeauth/gethistoryrecords'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getHistoryGround(request?:any) {
  return this.http.post(apiUrl('beforeauth/gethistorygrounddevelopment'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getEventWhatsnew(request?:any) {
  return this.http.post(apiUrl('beforeauth/geteventwhatsnew'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getProductMaster(request?:any) {
  return this.http.post(apiUrl('beforeauth/getproductmaster'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getProductSingle(request?:any) {
  return this.http.post(apiUrl('beforeauth/getproductmasterdetails'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getClubMeetboard(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubmeetboard'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getCricketevent(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcricketevent'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getClubGovernance(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubgovernance'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getClubAboutfox(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubaboutrunningfox'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getClubRunningkey(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubaboutrunningkeypillar'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getClubFriendsgrace(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubfriendsgraceroad'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}
getClubCommittee(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubcommittee'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getClubAccessstatement(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubaccessstatement'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getClubPremieroutdoor(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubpremieroutdoorvenue'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getClubPremieroutdoorimg(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubpremieroutdoorvenuetitle'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getClubContactus(request: any) {
  return this.http.post(apiUrl('beforeauth/contactus'), toFormData({ Contactus: request})).toPromise().then((data: any) => {            
      return data;
  })
}

RegisterYourInterest(request: any) {
  return this.http.post(apiUrl('beforeauth/registeryourinterest'), toFormData({ Registeryourinterest: request})).toPromise().then((data: any) => {            
      return data;
  })
}

SupportYourCounty(request: any) {
  return this.http.post(apiUrl('beforeauth/supportyourcounty'), toFormData({ Supportyourcounty: request})).toPromise().then((data: any) => {            
      return data;
  })
}
getClubContactpatrons(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubcontactpatrons'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getClubContact(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubcontact'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

newsSubscription(request?:any) {
  return this.http.post(apiUrl('beforeauth/newssubscription'), toFormData({ Newssubscription: request})).toPromise().then((data: any) => {            
    return data;
})
}

Addattendance(request?:any) {
  return this.http.post(apiUrl('beforeauth/addattendance'), toFormData({ Attendance: request})).toPromise().then((data: any) => {            
    return data;
})
}

Addfreeentryattendance(request?:any) {
  return this.http.post(apiUrl('beforeauth/addfreeentryformattendance'), toFormData({ Freeentryformattendance: request})).toPromise().then((data: any) => {            
    return data;
})
}

Addattendancetitle(request?:any) {
  return this.http.post(apiUrl('beforeauth/getattendancetitle'), toFormData({ Attendance: request})).toPromise().then((data: any) => {            
    return data;
})
}
getFreeentrytitle(request?:any) {
  return this.http.post(apiUrl('beforeauth/getfreeentryformtitle'), toFormData({ Attendance: request})).toPromise().then((data: any) => {            
    return data;
})
}
getClubRecruitment(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubrecruitment'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getClubDirections(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubdirections'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getClubGroundregulations(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubgroundregulations'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getFoundation(request?:any) {
  return this.http.post(apiUrl('beforeauth/getfoundation'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getCommercialFixture(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcommercialfixturetype'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getHistoryrichProud(request?:any) {
  return this.http.post(apiUrl('beforeauth/gethistoryrichproud'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getAcademy(request?:any) {
  return this.http.post(apiUrl('beforeauth/getacademy'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getLetest(request?:any) {
  return this.http.post(apiUrl('beforeauth/getletest'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getNewsDetails(request?:any) {
  return this.http.post(apiUrl('beforeauth/getnewsdetails'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getCommunitynewsDetails(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcommunitynewsdetails'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getclubsafeguarding(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubsafeguarding'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getCommunityaboutus(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcommunityaboutus'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getCommunity(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcommunity'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}
getCommunityStaff() {
  return this.http.post(apiUrl('beforeauth/getcommunitystaff'),{}).toPromise().then((data:any)=>{   
      return data;
  })
}

getCommunityTrustee() {
  return this.http.post(apiUrl('beforeauth/getcommunitytrusty'),{}).toPromise().then((data:any)=>{   
      return data;
  })
}

getCommunitywomencricket(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcommunitywomencricket'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getCommunityschool(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcommunityschool'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getCommunitygovernance(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcommunitygovernance'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getCommunityClub(request?:any) {
  return this.http.post(apiUrl('beforeauth/getcommunityclub'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getFoundationevent(request?:any) {
  return this.http.post(apiUrl('beforeauth/getfoundationevent'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getRunningfoxList(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubyourrunningfox'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}

getLookthepartList(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclublookthepart'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}
getJointheList(request?:any) {
  return this.http.post(apiUrl('beforeauth/getclubjointheconversation'),toFormData(request)).toPromise().then((data:any)=>{   
      return data;
  })
}


}
